import { memo } from 'react';
import { Button } from '@alf/uikit';
import { useI18n } from '@namespace/i18n';
import { useWheelCountdown } from '../../hooks/useWheelCountdown';

import styles from './index.module.css';

type CountdownProps = {
  spinTime: Date | null;
  onCountdownFinish: () => void;
  className?: string;
};

export const CountdownButton = memo(
  ({ spinTime, onCountdownFinish, className }: CountdownProps) => {
    const { t } = useI18n();
    const { countdown } = useWheelCountdown(spinTime, onCountdownFinish);

    return (
      <Button
        disabled={true}
        dataRole="spin-wheel-button"
        actionType="color5"
        className={`${styles.countdownButton} ${className}`}
      >
        {t('web.wheel.counter.button')}
        <br />
        {countdown}
      </Button>
    );
  }
);

CountdownButton.displayName = 'CountdownButton';
